/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TileRateApartment = {
    readonly roomType?: TileRateApartment.roomType;
    name?: string;
    type?: TileRateApartment.type;
    size?: number;
    singleBeds?: number;
    doubleBeds?: number;
    defaultGuests?: number;
};
export namespace TileRateApartment {
    export enum roomType {
        ROOM = 'room',
        SUITE = 'suite',
        APARTMENT = 'apartment',
        COMPLETE = 'complete',
    }
    export enum type {
        ROOM = 'room',
        RESIDENCE = 'residence',
        APARTMENT = 'apartment',
        COTTAGE = 'cottage',
        VILLA = 'villa',
        BUNGALOW = 'bungalow',
        AGROTOURISM = 'agrotourism',
        HOUSE = 'house',
    }
}
